function SetSessionPropertiesListener() {
}

module.exports = SetSessionPropertiesListener;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/set-session-properties-listener.js
// module id = 728
// module chunks = 1